import {useState} from 'react';

export default function useToken() {
    const getToken = () => {
        const tokenString = localStorage.getItem('token_user');
        return JSON.parse(tokenString)
    };

    const [token, setToken] = useState(getToken());

    const saveToken = userToken => {
        localStorage.setItem('token_user', JSON.stringify(userToken));
        setToken(userToken);
    };

    return {
        setToken: saveToken,
        resetToken: () => localStorage.removeItem('token_user'),
        token
    }
}